import { createAction } from '@wix/communities-blog-client-common';

export const SEARCH_SUBMITTED = 'blog/SEARCH_SUBMITTED';

export const searchSubmitted = createAction(SEARCH_SUBMITTED);
